import App from './App';
import XeroSignup from './XeroSignup';
import {createRoot} from 'react-dom/client';

const el = document.getElementById('root');
if (el === null) throw new Error('Root container missing in index.html');

const root = createRoot(el);
root.render(
  <App>
    <XeroSignup />
  </App>
);
